export default {
  namespace: 'banners',
  action: 'ia-banner-close',
  selector: '.ia-banner',

  /**
   * DOM onclick event triggered to dismiss a banner.
   * @param {object} jQuery decorated event
   */
  dismiss(e) {
    e.preventDefault();
    const banner = e.currentTarget.closest(this.selector);
    if (this.isLocalStorageAvailable()) {
      this.writeStorage(banner.getAttribute('data-campaign'));
    }
    banner.remove();
  },

  /**
   * Reads an array of any dismissed banners.
   * @return {array}
   */
  readStorage() {
    return JSON.parse(localStorage.getItem(this.namespace)) || [];
  },

  /**
   * Writes the banner campaign ID to the array of dismissed banners.
   * @param {string}
   */
  writeStorage(campaign) {
    const dismissedBanners = this.readStorage();
    localStorage.setItem(this.namespace, JSON.stringify([...dismissedBanners, campaign]));
  },

  /**
   * Binds click to dismiss event to banners.
   */
  bindEvents() {
    document.querySelectorAll(`${this.selector} [data-action=${this.action}]`).forEach((e) => {
      e.addEventListener('submit', (el) => {
        this.dismiss(el);
        return false;
      });
    });
  },

  /**
   * Checks each banner against the dismissed banners list and toggles
   * visibility.
   */
  checkVisibility() {
    const dismissedBanners = this.isLocalStorageAvailable() ? this.readStorage() : [];

    document.querySelectorAll(this.selector).forEach((el) => {
      el.classList.toggle('visible', !dismissedBanners.includes(el.getAttribute('data-campaign')));
    });
  },

  /**
   * Catch error when user has disabled third-party cookies/storage.
   * @returns {Boolean}
   */
  isLocalStorageAvailable() {
    try {
      return Object.keys(localStorage).length >= 0;
    } catch {
      return false;
    }
  },

  /**
   * Does what it says on the tin.
   */
  init() {
    this.bindEvents();
    this.checkVisibility();
  },
};
